import React from 'react';
import { Col, Layout, Row } from 'antd';

const { Content } = Layout;

const IntroductionPage = () => {
  return (
    <Content
      className="flex flex-col overflow-auto"
      style={{
        backgroundImage: `url(${require('../images/6793883d4f521e8b9bfa7d2a_stripes-hor-on-dark.jpg')})`,
      }}>
      <Row>
        <Col span={20} offset={2}>
          <Col span={24} className="py-10 flex justify-center">
            <img src={require('../images/DataBase_Files.H03.png')} alt="Dokapi header graphic" height="300" />
          </Col>
          <Col className="mt-8 border-t border-blue-300 border-solid border-0 pt-8">
            <h1 className="text-white text-4xl font-bold mb-1">Automating digital document processing</h1>
          </Col>
          <Col className="mt-10">
            <p className="text-white text-lg font-normal mb-4">
              This demo showcases the possibilities AI & ML models offer in automating repetitive tasks. Tasks that,
              until now, required manual intervention. Automating these tasks enable a fully automated end to end
              document flow.
            </p>
            <p className="text-white text-lg font-normal mb-4">
              The end to end Peppol flow offered by Dokapi uses the Invoice Recognition model to automatically convert
              documents in PDF format or scanned format into UBL format.
            </p>
            <p className="text-white text-lg font-normal mb-4">
              Are you interested in evaluating our models, let us know!
            </p>
          </Col>
        </Col>
      </Row>
    </Content>
  );
};

export default IntroductionPage;
